/**
 * The single width at which the layout switches between the permanent sidebar
 * and the mobile bar + drawer.
 *
 * Both sides must read this same value. They used to disagree -- the sidebar
 * docked at MUI's `xl` (1920px) while the mobile bar only appeared below 992px,
 * so between 992px and 1919px the page had neither a sidebar nor a hamburger
 * and there was no way to navigate at all.
 */
export const DESKTOP_MEDIA_QUERY = "(min-width:992px)";
